/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_Notes_CheckInputs */



/**
* | output |
* | --- |
* | "Include Notes Checked" |
*
* @param {Transcript_Export_Include_Notes_CheckInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_notes_check = /** @type {((inputs?: Transcript_Export_Include_Notes_CheckInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_Notes_CheckInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Include Notes Checked")
	if (locale === "de") return /** @type {LocalizedString} */ ("Include Notes Checked")
	if (locale === "it") return /** @type {LocalizedString} */ ("Include Notes Checked")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Include Notes Checked")
	if (locale === "es") return /** @type {LocalizedString} */ ("Include Notes Checked")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Include Notes Checked")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Include Notes Checked")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Include Notes Checked")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Include Notes Checked")
	return /** @type {LocalizedString} */ ("Include Notes Checked")
});